/**
 * IncomingPurchaseDocuments API - Auto-generated typed wrapper.
 * DO NOT EDIT - Regenerate with: bun run generate
 * @generated
 */

import {
  createCustomIncomingPurchaseDocument,
  createIncomingPurchaseDocument,
  deleteIncomingPurchaseDocumentAttachment,
  getIncomingPurchaseDocumentById,
  getIncomingPurchaseDocuments,
  updateIncomingPurchaseDocument,
  uploadIncomingPurchaseDocumentAttachment,
} from "../generated/incoming-purchase-documents/incoming-purchase-documents";

import { wrapListMethod, wrapMethod } from "./utils";

export const incomingPurchaseDocuments = {
  /** @see createIncomingPurchaseDocument */
  create: wrapMethod(createIncomingPurchaseDocument),

  /** @see getIncomingPurchaseDocuments */
  list: wrapListMethod(getIncomingPurchaseDocuments),

  /** @see createCustomIncomingPurchaseDocument */
  createCustom: wrapMethod(createCustomIncomingPurchaseDocument),

  /** @see getIncomingPurchaseDocumentById */
  get: wrapMethod(getIncomingPurchaseDocumentById),

  /** @see updateIncomingPurchaseDocument */
  update: wrapMethod(updateIncomingPurchaseDocument),

  /** @see uploadIncomingPurchaseDocumentAttachment */
  uploadIncomingPurchaseDocumentAttachment: wrapMethod(uploadIncomingPurchaseDocumentAttachment),

  /** @see deleteIncomingPurchaseDocumentAttachment */
  delete: wrapMethod(deleteIncomingPurchaseDocumentAttachment),
} as const;

export type IncomingPurchaseDocumentsApi = typeof incomingPurchaseDocuments;
